<div class="workspace no-back-btn">
  <div class="row" id="influencer-inbox-management">
    <div class="col-md-12 d-none d-md-flex influencer-inbox-breadcumb">
      <div class="col-md-8 col-sm-8">
        <div class="row">
          <div class="col-md-12 col-sm-12 breadcumb-header">
            <div class="d-flex flex-row flex-wrap">
              <div class="d-flex flex-row align-items-center">
                <a class="not-underline first-line text-semi-bold-font">{{"inbox.inbox" | translate}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-4 d-flex justify-content-end">
        <div class="search-box-container">
          <achoo-text-field
            placeholder="{{ 'inbox.search.placeholder' | translate }}"
            placement="bottom"
            ngbTooltip="{{'inbox.search.tooltip' | translate}}"
            [isPageSearch]="true"
            [(model)]="searchContent"
          >
          </achoo-text-field>
        </div>
      </div>
    </div>
    <div class="col-md-12 influencer-inbox-body">
      <div class="row">
        <div class="col-xl-3 col-md-4 col-sm-12 recent-messages-wrapper" [ngClass]="{'on-chat-view': isAMessageSelected()}">
          <div class="row recent-messages">
            <div class="col-md-12 d-flex flex-row">
              <div class="d-none d-md-flex flex-auto recent-messages-header">
                {{ "inbox.recent_messages" | translate }}
                <span class="counting" *ngIf="unReadMessageCounting > 0">{{unReadMessageCounting}}</span>
              </div>
              <div class="d-flex d-md-none flex-auto recent-messages-header">
                {{ "inbox.inbox" | translate }}
                <span class="counting" *ngIf="unReadMessageCounting > 0">{{unReadMessageCounting}}</span>
              </div>
              <div class="d-none d-md-flex flex-row">
                <a class="recent-message-actions" (click)="editMessages($event)">{{'common.btn.edit' | translate}}</a>
              </div>
            </div>
            <div class="col-md-12 recent-messages-container">
              <conversation-list [conversations]="sortedConversationList"
                                 [editable]="editingMessages"
                                 (removeConversation)="onConfirmRemoveConversation($event)"
                                 (selectConversation)="onSelectConversation($event)"
                                 (fetchNextConversations)="fetchNextConversation()">
              </conversation-list>
            </div>
          </div>
          <div class="d-block d-md-none bottom-fade"></div>
        </div>
        <div class="col-xl-9 col-md-8 col-sm-12 d-none d-md-block chat-history-container" [ngClass]="{'on-chat-view': isAMessageSelected()}">
          <div class="chat-history-inner" *ngIf="selectedConversation">
            <div class="thread-host d-none d-md-block">
              <span>{{getActiveConversationName(selectedConversation)}}</span>
            </div>
            <div class="thread-messages">
              <influencer-chat [conversation]="selectedConversation"
                               [showActivityLog]="showActivityLog"
                               (afterReadLastMessage)="onReadLastMessages($event)"
                               (newMessageAdded)="newMessageAdded($event)"></influencer-chat>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="bottombar bottom-bar" *ngIf="isAMessageSelected()">
  <div class="buttons d-md-none">
    <button class="button cerise-red" (click)="backToInbox()">{{'common.btn.back' | translate}}</button>
  </div>
</div>
<achoo-popup #confirmRemoveMessageDialog
             modelTitle="{{'inbox.remove_message.title' | translate}}"
             acceptBtnLabel="{{'inbox.remove_message.btn_confirm' | translate}}"
             cancelBtnLabel="{{'inbox.remove_message.btn_cancel' | translate}}"
             (acceptCallback)="confirmBeforeRemovingConversation()"
             (cancelCallback)="closeConfirmRemoveConversation()">
  <div class="d-flex flex-column flex-auto">
    <span>{{'inbox.remove_message.message' | translate: {sender: conversationToRemove?.name} }}</span>
  </div>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/influencer-inbox/influencer-inbox.component.html